import React, {useEffect} from "react";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";
import BsForm from "components/form/BsForm";
import CHANGE_INFO_PRIORITY_FORM from "./change-issue-priority-form";

import 'components/model/confirmation-model.scss';

const ChangePriorityModel = (props) => {
    const {t} = useTranslation();
    let fields = {};

    useEffect(() => {
        BsForm.addValidationRule('requiredPriority', (value) => {
            return !!fields.priority;
        });

        return () => {
            BsForm.removeValidationRule('requiredPriority');
        };
    });

    const onSubmit = () => {
        props.handleSubmit(fields.priority)
    }

    const handleChange = (newData) => {
        fields = newData;
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="model-window"
            open={props.open}
            onClose={props.handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}>
            <Fade in={props.open}>
                <div className="model-container">
                    <div className="model-body">
                        <h4>{t(props.message)}</h4>

                        <BsForm
                            config={CHANGE_INFO_PRIORITY_FORM}
                            onHandleSubmit={onSubmit}
                            onHandleChange={handleChange}
                            cancelAction={<Button variant="outlined" onClick={props.handleClose}>
                                {t('general.cancel')}
                            </Button>}
                        />
                    </div>
                </div>
            </Fade>
        </Modal>
    )
}

ChangePriorityModel.propTypes = {
    open: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    handleClose: PropTypes.any.isRequired,
    handleSubmit: PropTypes.any.isRequired
};

export default ChangePriorityModel;